import React from 'react';
import classnames from 'classnames';
import duperbrowsePaddleStyles from './DuperbrowsePaddles.scss';
export var DuperbrowsePaddle = function (_a) {
    var children = _a.children, className = _a.className, onClick = _a.onClick, isEnabled = _a.isEnabled, dataHook = _a.dataHook;
    return (React.createElement("div", { className: classnames(duperbrowsePaddleStyles['duper'], className, isEnabled && duperbrowsePaddleStyles['enabled']), "data-hook": dataHook }, isEnabled ? React.createElement("a", { onClick: onClick }, children) : React.createElement(React.Fragment, null, children)));
};
DuperbrowsePaddle.displayName = 'DuperbrowsePaddle';
export default DuperbrowsePaddle;
//# sourceMappingURL=DuperbrowsePaddle.js.map